import { useMemo } from 'react';

import { getJobBoardClientNameFromLocalStorage } from 'helpers/jobBoardClientNameLocalStorage/getJobBoardClientNameFromLocalStorage';

export const useIsMoj = () => {
  const currentClient = getJobBoardClientNameFromLocalStorage();

  return useMemo(() => {
    switch (currentClient) {
      case 'staging-moj':
      case 'moj':
        return true;
      default:
        return false;
    }
  }, [currentClient]);
};
